import { Avatar, Menu } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useTrans } from "core/index.js";
const UserAvatar = () => {
	const navigate = useNavigate();

	const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
	const { t } = useTrans();
	const handleLogin = () => navigate("/login");
	const handleSignup = () => navigate("/signup");
	// const handleProfile = () => navigate("/profile");
	const handleLogout = () => {
		try {
			localStorage.removeItem("token");
		} catch (e) {}
		navigate("/");
		// reload to refresh auth-dependent UI
		window.location.reload();
	};

	if (!token) {
		// Not authenticated: show a small menu to go to login/signup
		return (
			<Menu withArrow position="bottom-end">
				<Menu.Target>
					<Avatar color="blue" size={"md"} style={{ cursor: "pointer" }} />
				</Menu.Target>
				<Menu.Dropdown>
					<Menu.Item onClick={handleLogin}>{t("login.login")}</Menu.Item>
					<Menu.Item onClick={handleSignup}>{t("login.signup")}</Menu.Item>
				</Menu.Dropdown>
			</Menu>
		);
	}

	// Authenticated: show profile + logout
	return (
		<Menu withArrow position="bottom-end">
			<Menu.Target>
				<Avatar color="blue" size={"md"} style={{ cursor: "pointer" }} />
			</Menu.Target>
			<Menu.Dropdown>
				<Menu.Item color="red" onClick={handleLogout}>
					{t("drawer.LogOut")}
				</Menu.Item>
			</Menu.Dropdown>
		</Menu>
	);
};

export default UserAvatar;
